import React, { useEffect, useState } from "react"
import { Box, Text, Textarea, TextareaProps } from "@chakra-ui/react"

export interface FormTextareaProps extends TextareaProps {
  value: string
  limit?: number
}

export const FormTextarea = ({ value, onChange, limit, ...props }: FormTextareaProps) => {
  const [invalid, setInvalid] = useState<boolean>(false)

  useEffect(() => {
    if (limit && value?.length > limit) setInvalid(true)
  }, [limit, value])

  return (
    <Box>
      <Textarea {...props} value={value} onChange={onChange} isInvalid={invalid} maxLength={limit} />
      {limit && (
        <Text mt={0.5} size="xs" color={invalid ? "brand.sale" : "text.secondary"}>
          {value.length}/{limit} characters
        </Text>
      )}
    </Box>
  )
}
